import React, { ChangeEvent } from 'react';
import { messagesStore } from '../../store/messages';
import { IMessageModal } from '../../types/messages';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { formatPrice } from 'src/utils/formatter';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Icon from 'src/view/components/Controls/Icon/Icon';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  input?: string;
  price: number;
  data?: IMessageModal;
  onSubmit: (reason: string) => void;
}

interface IState {
  input: string;
  isSubmitFailed: boolean;
}

export default class RefundReasonMessage extends React.Component<IProps, IState> {
  state: IState = {
    input: this.props.input || '',
    isSubmitFailed: false,
  };

  handleInput = (e: ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ input: e.target.value });
  };

  submit = () => {
    if (this.state.input) {
      this.props.onSubmit(this.state.input.trim());
      this.setState({ isSubmitFailed: false, input: '' });

      messagesStore.removeMessage('refund-reason-message');
    } else {
      this.setState({ isSubmitFailed: true });
    }
  };

  render() {
    return (
      <ModalBackground className="refund-reason-message__wrapper">
        <Icon name={Icons.Warning} size={90} className="color-red" />
        <Text
          type={TEXT.MODAL_MESSAGE}
          text={localeStore.t('ask_reason_for_refund') + ' ' + formatPrice(this.props.price)}
          noTranslate
          className="mt-8 mb-5"
        />
        <div className="d-flex flex-column">
          <textarea
            value={this.state.input}
            onChange={this.handleInput}
            maxLength={160}
            placeholder={localeStore.t('type_reason')}
            className={`refund-reason-message__text-area letter-spacing-5 ${this.state.isSubmitFailed ? 'input-error' : ''}`}
          />
          {this.state.isSubmitFailed ? <Text type={TEXT.ERROR} text="txt_required" /> : null}
        </div>

        <Button title={localeStore.t('refund')} onClick={this.submit} size="large" className="mt-8" />
      </ModalBackground>
    );
  }
}
